import { useEffect } from "react";

export const useTimeout = (reauthenticated, setReauthenticated) => {
    return useEffect(() => {
        if (!reauthenticated) return;

        let timeout;

        const resetTimer = () => {
            clearTimeout(timeout);

            timeout = setTimeout(
                () => {
                    setReauthenticated(false);
                },
                5 * 60 * 1000,
            );
        };

        const events = ["mousemove", "keydown", "click", "scroll"];

        events.forEach((e) => window.addEventListener(e, resetTimer));

        resetTimer();

        return () => {
            events.forEach((e) => window.removeEventListener(e, resetTimer));
            clearTimeout(timeout);
        };
    }, [reauthenticated, setReauthenticated]);
};
